import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Plug, Unplug } from "lucide-react";

interface ConnectionStatusProps {
  isConnected: boolean;
  isLoading: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
  showQRCode: boolean;
}

export const ConnectionStatus = ({
  isConnected,
  isLoading,
  onConnect,
  onDisconnect,
  showQRCode,
}: ConnectionStatusProps) => {
  if (isConnected) {
    return (
      <div className="space-y-6 w-full">
        <div className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-center">
          WhatsApp conectado com sucesso!
        </div>
        <Button
          onClick={onDisconnect}
          variant="destructive"
          className="w-full"
        >
          <Unplug className="mr-2" />
          Desconectar WhatsApp
        </Button>
      </div>
    );
  }

  return (
    <Button
      onClick={onConnect}
      disabled={isLoading || showQRCode}
      className="w-full max-w-sm"
    >
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Verificando conexão...
        </>
      ) : showQRCode ? (
        "Aguardando leitura do QR Code..."
      ) : (
        <>
          <Plug className="mr-2" />
          Conectar WhatsApp
        </>
      )}
    </Button>
  );
};